import ImageListItemBar from '@mui/material/ImageListItemBar';
import CircularProgress from '@mui/material/CircularProgress';
import ImageListItem from '@mui/material/ImageListItem';
// import AudioPlayer from 'material-ui-audio-player';
import ImageList from '@mui/material/ImageList';
import MenuItem from '@mui/material/MenuItem';
import {useTranslation} from "react-i18next";
// import {AudioCard} from 'material-ui-player'
import Menu from '@mui/material/Menu';
import Grid from '@mui/material/Grid';
import React, {useState} from 'react';
import {observer} from 'mobx-react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import UploadButton from '../UploadButton.js';
import MediaDialog from './MediaDialog.js';
import {TAB_MEDIA} from './TaxCommon.js';
import {COMM_OK} from '../WsR2.js';

/* Media type identifiers */
export const MTI_UNDEF	= 1
export const MTI_JPG	= 2
export const MTI_MP3	= 3
export const MTI_PNG	= 4
export const MTI_PDF	= 5
export const MTI_WAV	= 6
export const MTI_ODT	= 7
export const MTI_XWAV	= 8

/* Target table database identifiers */
export const TTID_OBS	= 1
export const TTID_TAXONS= 2

const TitlebarBelowImageList = observer((props) => {
	const gStorage = useGlobalStorage();

	if (!gStorage.taxons.mediaList)
		return null;

	return (
		<ImageList sx={{ width: 300, align: 'center' }} cols={1}>
			{gStorage.taxons.mediaList && gStorage.taxons.mediaList.map((item, pos) => (
				<ImageListItem key={item.id} onClick={props.onClick.bind(this, item, pos)} onContextMenu={props.contextClick.bind(this, item, pos)}>
					{item.src ? 
					<img
						src={item.src}
						srcSet=""
						alt={item.name}
						loading="lazy"/> :
					 <Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
						<CircularProgress/>
					</Grid>
					}
					<ImageListItemBar
						title={item.caption}
						subtitle={<span>{item.copyright.length ? '©' + item.copyright : ''}</span>}
						position="below"
					/>
				</ImageListItem>
			))}
		</ImageList>
	);
});

const TaxMedia = observer((props) => {
	const [mediaDlgIsOpen, setMediaDlgOpen] = useState(false);
	const [mediaPos, setMediaPos] = useState(-1);
	const [menuPos, setMenuPos] = useState(null);
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function filterMedia(list) {
		let l2 = list.sort((f1, f2) => {
				return f2.upload_t - f1.upload_t;
			});

		return l2.filter((f) => {
				return f.tt_id === TTID_TAXONS && (f.mt_id === MTI_JPG || f.mt_id === MTI_PNG);
			});
	}

	function mediaRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('mediaRxWs: error ', status, msg);
			return -1;
		}

		if (msg.cmd === 'tax' && msg.op === 'media') {
			if (msg.result === 'OK') {
// 				console.log('mediaRxWs:', msg.data.media);

				gStorage.taxons.setMediaList(filterMedia(msg.data.media));
				gStorage.taxons.setLoadPos(0);

				if (gStorage.taxons.mediaList.length) {
					loadMedia(gStorage.taxons.mediaList[gStorage.taxons.loadPos]);
				}
			} else {
				console.error('mediaRxWs: medialist load failed!');
			}
		} else if (msg.cmd === 'file') {
			if (msg.op === 'download') {
				let new_pos;

// 				console.log('mediaRxWs:', gStorage.taxons.loadPos, msg.data.file);

				if (msg.result === 'OK') {
					gStorage.taxons.setMediaSrc(gStorage.taxons.loadPos, msg.data.file.content);
				} else {
					console.error('mediaRxWs:', gStorage.taxons.mediaList[gStorage.taxons.loadPos].name, 'load failed at', gStorage.taxons.loadPos, '!');
					gStorage.taxons.setMediaSrc(gStorage.taxons.loadPos, "");
				}

				new_pos = gStorage.taxons.loadPos + 1;
				gStorage.taxons.setLoadPos(new_pos);

				if (gStorage.taxons.loadPos < gStorage.taxons.mediaList.length) {
// 					console.log('loadPos', gStorage.taxons.loadPos);
					loadMedia(gStorage.taxons.mediaList[gStorage.taxons.loadPos]);
				}
			} else if (msg.op === 'detach') {
				loadMediaList(gStorage.taxons.centerTaxon);
			} 
		} else {
			console.error('mediaRxWs: unknown command', msg.cmd, msg.op);
		}
	}

	function loadMedia(m) {
// 		console.log('loadMedia', m.id, m.name);
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'file',
			op: 'download',
			data: {
				file: {
					id: m.id,
				}
			}
		};

// 		console.log('loadMedia', msg);
		gStorage.conn.ws.send(msg, mediaRxWs);
	}

	function loadMediaList(tax) {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'tax',
			op: 'media',
			data: {
				taxon: {
					id: tax.id,
				}
			}
		};

// 		console.log('loadMediaList', msg);
		gStorage.conn.ws.send(msg, mediaRxWs);
	}

	function refreshMedia() {
		loadMediaList(gStorage.taxons.centerTaxon);
	}

	/* Left click on image. */
	function imageClick(img, pos, ev) {
		gStorage.taxons.setEditMedia(gStorage.taxons.mediaList[pos]);
		setMediaPos(pos);
		setMediaDlgOpen(true);
	}

	/* Right click when menu is open: close menu! */
	function onMenuContextClick(ev) {
		ev.preventDefault();
		setMenuPos(null);
	}

	function contextClick(img, pos, ev) {
// 		console.log('contextClick', img, pos);

		ev.preventDefault();
		setMenuPos(menuPos === null ? {mouseX: ev.clientX - 2, mouseY: ev.clientY - 4, img: img, imgPos: pos} : null);
	}

	function handleMenuClose() {
		setMenuPos(null);
	};

	function handleImageDelete() {
		console.log('handleImageDelete', menuPos.img.id, menuPos.img.name);

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'file',
			op: 'detach',
			data: {
				file: {
					id: menuPos.img.id,
				},
				target: {
					table: 'taxons',
					id: gStorage.taxons.centerTaxon.id
				}
			}
		};

		gStorage.conn.ws.send(msg, mediaRxWs);
		setMenuPos(null);
	}

	function openMediaProps() {
// 		console.log('openMediaProps');
		gStorage.taxons.setEditMedia(gStorage.taxons.mediaList[menuPos.imgPos]);
 		setMediaPos(menuPos.imgPos);
		setMenuPos(null);
		setMediaDlgOpen(true);
	}

	function onMediaDlgClose() {
// 		console.log('onMediaDlgClose');
		setMediaDlgOpen(false);
	}

	/* ------------------------------------------------------------------ */

	if (gStorage.taxons.tab !== TAB_MEDIA)
		return null;

	if (!gStorage.taxons.centerTaxon) 
		return null;

	if (!gStorage.taxons.mediaList && gStorage.conn.online) {
		loadMediaList(gStorage.taxons.centerTaxon);
		return null;
	}

	/* Add/remove allowed for admins only! */
	const isAdmin = gStorage.conn.is_auth && gStorage.conn.online && gStorage.conn.user._access;

	/* const aSrc = [
		"https://xeno-canto.org/349842/download"
	];
		const aSrc = [
		"https://xeno-canto.org/349842/download"
	]
				<Grid size={{xs: 12}} align={'center'}>
					<AudioPlayer
					    width="300px"
					    elevation={1}
					    variation="primary"
					    loop={false}
					    volume={false}
					    download={false}
					    order="standart"
					    spacing={0}
					    debug={false}
					    src={aSrc}
					/>
				</Grid>
	*/

	return (<div>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} align={'center'}>
					<TitlebarBelowImageList onClick={imageClick} contextClick={contextClick}/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					{isAdmin ? 
						<UploadButton 
						  refresh={refreshMedia} 
						  target={{table: 'taxons', id: gStorage.taxons.centerTaxon.id}}
						  caption = 'common.add_image'
						/> : null}
				</Grid>
			</Grid>
			<Menu
				onContextMenu={onMenuContextClick}
				open={menuPos !== null}
				onClose={handleMenuClose}
				anchorReference="anchorPosition"
				anchorPosition={
					menuPos !== null ? { top: menuPos.mouseY, left: menuPos.mouseX } : undefined
				}
			>
				{
				isAdmin ? <MenuItem onClick={handleImageDelete}>
						{t('media.delete')}
					</MenuItem>
					: 
					null
				}
				<MenuItem onClick={openMediaProps}>
					{t('media.properties')}
				</MenuItem>
			</Menu>
			<MediaDialog isOpen={mediaDlgIsOpen} handleClose={onMediaDlgClose} mediaPos={mediaPos} />
	       </div>);
});

export default TaxMedia;
